module.exports = __webpack_public_path__ + "img/client-emporio-terra-brasil.cefa4ee2.png";